import { ManagerError } from './error-parser';
import { RequestState } from './remote-data';

export interface EntityData<T, ValidationsType = unknown> {
  data?: T;
  query: {
    state: RequestState;
    error?: ManagerError<ValidationsType>;
  };
  mutation: {
    state: RequestState;
    error?: ManagerError<ValidationsType>;
  };
}

export function initialEntityData<T, V = unknown>(): EntityData<T, V> {
  return {
    query: { state: 'initial' },
    mutation: { state: 'initial' }
  };
}
